var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAttachMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 18 19",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 5L8.25 8.75L14.25 5V7.25H15.75V3.5C15.75 2.675 15.075 2 14.25 2H2.25C1.425 2 0.7575 2.675 0.7575 3.5L0.75 12.5C0.75 13.325 1.425 14 2.25 14H9.75V12.5H2.25V5ZM14.25 3.5L8.25 7.25L2.25 3.5H14.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 11V14C15.75 14.825 15.075 15.5 14.25 15.5C13.425 15.5 12.75 14.825 12.75 14V10.625C12.75 10.415 12.915 10.25 13.125 10.25C13.335 10.25 13.5 10.415 13.5 10.625V14H15V10.625C15 9.59 14.16 8.75 13.125 8.75C12.09 8.75 11.25 9.59 11.25 10.625V14C11.25 15.6575 12.5925 17 14.25 17C15.9075 17 17.25 15.6575 17.25 14V11H15.75Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachMail);
export default __webpack_public_path__ + "static/media/attach-mail.f6f8376044ac6bbcf1ec16d27d1780ad.svg";
export { ForwardRef as ReactComponent };